import { ProfileType } from '@ixicare/resources';
import * as React from 'react';
import { observer } from 'mobx-react';
import { t } from '~/i18n';
import UserProfileEntry from '~store/Profile/UserProfileEntry';
import ProfileFormContainer from '../Profile/ProfileForm';
import { useStores } from '~store/utils';

interface HealthcareProviderFormContainerProps {
  healthcareProvider?: UserProfileEntry;
}

const HealthcareProviderFormContainer: React.FC<HealthcareProviderFormContainerProps> = observer(
  ({ healthcareProvider }) => {
    const { permissions } = useStores();
    const isCreate = !healthcareProvider;

    if (isCreate && !permissions.has('can_create_profiles')) {
      return <p>{t('user-configuration.no-permissions')}</p>;
    }
    return (
      <ProfileFormContainer
        profileType={ProfileType.HealthcareProvider}
        fields={['email', 'password', 'phoneNumbers']}
        profile={healthcareProvider}
        urlPath="healthcare-providers"
        storeType={'healthcareProviders'}
        donePath={'/healthcare-providers'}
      />
    );
  }
);

export default HealthcareProviderFormContainer;
